import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../icon/Icon";

const Backbutton = () => {

    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/login');
    };

    return(
        <div className="mt-5">
            <button className="flex justify-center items-center gap-1 text-primary text-medium w-full" onClick={handleBack}>
                <Icon name="back" layoutClass="h-4 w-4"/>
                Back to home
            </button>
        </div>
    )
}

export default Backbutton;